import { render, staticRenderFns } from "./WhizeoHealthScore.vue?vue&type=template&id=1995c9d8&scoped=true&"
import script from "./WhizeoHealthScore.vue?vue&type=script&lang=js&"
export * from "./WhizeoHealthScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995c9d8",
  null
  
)

export default component.exports